import React from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";

const Hero = () => (
  <div className="text-center hero my-5">
    <img 
      className="mb-3 app-logo" 
      src={`${process.env.PUBLIC_URL || ''}/wideby-logo.png`} 
      alt="Wideby Logo" 
      width="500" 
      style={{ width: '500px', height: 'auto' }}
    />
    <h1 className="mb-4">Deals and services near you</h1>

    <p className="lead mb-4">
       Find relevant local deals and services. Enter your location, browse and book quickly and easily.
    </p>

    <Link to="/deals">
      <Button color="primary" size="lg" className="px-4 py-2">
        Find deals near me
      </Button>
    </Link>
  </div>
);

export default Hero;
